<div #restart class="restart" *ngIf="time">
    Tippen Sie auf den Bildschirm um fortzufahren.
    <div class="timer-container">
        <div class="timer">
            <div class="mask"></div>
        </div>
        <div class="time">{{time}}</div>

    </div>

</div>
<router-outlet></router-outlet>
<div #fallback class="modal" *ngIf="fallback">
    <div class="modal-body">
        <div class="modal-content">
            <div class="close" (click)="stopFallback()"><i class="fa-solid fa-circle-xmark"></i>schliessen</div>
            <div class="details">
                <i class="fa-solid fa-circle-exclamation"></i>
                <div class="sub-details">Einkauf wird zurückgesetzt</div>
                <p>Der Einkauf wird in <span>{{seconds}}</span> Sekunden abgebrochen.</p>
                <p class="subtle-button" (click)="finishFallback()">Sofort zurücksetzen</p>
            </div>
        </div>
        <div class="submit" (click)="stopFallback()">Mit Einkauf fortfahren
        </div>
    </div>
</div>
<app-error-modal></app-error-modal>